import { signOut } from "next-auth/react"

// Sign the user out and send them to `destination` on the **current** host.
//
// next-auth resolves signOut's `callbackUrl` against `NEXTAUTH_URL` - a single
// fixed origin baked into the deployment. With one deployment serving every
// workspace on its own subdomain (`app.<root>`, `premieroctet.<root>`, ...),
// that origin is never guaranteed to be the one the user is on, so letting
// next-auth perform the redirect bounces them to another subdomain - and when
// `NEXTAUTH_URL` is the bare root domain, to a host that immediately 301s away
// with the session already cleared. Doing the navigation ourselves keeps it
// same-origin, on whichever workspace the user was actually using.
export async function signOutToCurrentHost(destination = "/") {
  await signOut({ redirect: false })
  window.location.assign(destination)
}

export const isSafeRedirect = (path: unknown): path is string =>
  typeof path === "string" &&
  path.startsWith("/") &&
  !path.startsWith("//") &&
  !path.startsWith("/\\") &&
  !path.startsWith("/auth")

export const loginPathReturningTo = (path?: string) =>
  isSafeRedirect(path)
    ? `/auth/login?redirect=${encodeURIComponent(path)}`
    : "/auth/login"
